/** Relative-time + staleness helpers for as-of labels. Pure; unit-tested. */

export function relativeAgo(iso: string, now: Date = new Date()): string {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return '—';
  const sec = Math.max(0, (now.getTime() - t) / 1000);
  if (sec < 90) return 'just now';
  if (sec < 3600) return `${Math.round(sec / 60)}m ago`;
  if (sec < 48 * 3600) return `${Math.round(sec / 3600)}h ago`;
  return `${Math.round(sec / 86400)}d ago`;
}

export function isStale(iso: string, maxAgeHours: number, now: Date = new Date()): boolean {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return true;
  return now.getTime() - t > maxAgeHours * 3600_000;
}
